import { List } from "../../../store/system/types";
import { TypeIdentification, Relationship, Gender } from "../../../store/medicalAppointment/types";

export const typeIdentification: List[] =
    [
        { id: "", value: 'Tipo de identificación' },
        { id: TypeIdentification.IdentificationCard, value: TypeIdentification.Value_IdentificationCard },
        { id: TypeIdentification.ForeignId, value: TypeIdentification.Value_ForeignId },
        { id: TypeIdentification.Passport, value: TypeIdentification.Value_Passport }
    ];
export const relationship: List[] =
    [
        { id: "", value: 'Indique su parentesco' },
        { id: Relationship.Hijos, value: Relationship.Value_Hijos },
        { id: Relationship.Conyuge, value: Relationship.Value_Conyuge }
    ];
export const  gender: List[] =
    [
        { id: "", value: 'Indique su género' },
        { id: Gender.Male, value: Gender.Value_Male },
        { id: Gender.Female, value: Gender.Value_Female }
    ];
